import { device } from 'src/styles/breakpoints'
import { orange, white } from 'src/styles/colors'
import styled from 'styled-components'

export const Section = styled.section`
  background-image: url('https://central-imagens.bancointer.com.br/523c63a0/background-1440.webp');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 772px;
`

export const BoxContet = styled.div`
  background: rgba(104, 104, 104, 0.2);
  padding: 24px;
  border-radius: 16px;
  width: 100%;
  min-height: 428px;
  box-sizing: border-box;

  form {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;

    .form-group {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    label {
      font-size: 14px;
      line-height: 17px;
      font-weight: 400;
      color: ${white};
      margin-bottom: 0px;
    }

    button {
      background: ${orange.base};
      border-radius: 8px;
      width: 100%;
      max-width: 100%;
      height: 48px;
      padding: 16px;
      color: #fff;
      border: none;
      box-sizing: border-box;
      flex-shrink: 0;
    }

    button {
      cursor: pointer;
    }
  }

  input {
    background: ${white};
    border-radius: 8px;
    width: 100%;
    max-width: 100%;
    height: 48px;
    padding: 16px;
    border: none;
    box-sizing: border-box;
  }
`

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.4);
`

export const ModalContent = styled.div`
  position: relative;
  width: 374px;
  height: 381px;
  max-width: calc(100% - 32px);
  background: #353539;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 24px;
  box-sizing: border-box;
  text-align: center;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
`

export const ModalIcon = styled.img`
  width: 80px;
  height: 80px;
  object-fit: contain;
  margin-bottom: 24px;
`

export const ModalTitle = styled.h4`
  font-size: 20px;
  line-height: 25px;
  font-weight: 600;
  color: ${white};
  margin: 0 0 8px;
`

export const ModalDescription = styled.p`
  font-size: 14px;
  line-height: 17px;
  font-weight: 400;
  color: ${white};
  margin: 0 0 24px;
`

export const ModalButton = styled.button`
  background: ${orange.base};
  border-radius: 8px;
  width: 100%;
  height: 48px;
  padding: 16px;
  color: ${white};
  border: none;
  font-size: 14px;
  line-height: 17px;
  font-weight: 700;
  cursor: pointer;
`

export const ModalCloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const SubTitle = styled.h1`
  margin-top: 34.94px;
  font-size: 16px;
  line-height: 20px;
  font-weight: 400;
  color: ${white};
  letter-spacing: 0;
  margin-bottom: 40px;

  @media ${device.tablet} {
    margin-bottom: 0;
  }
  @media ${device.desktopLG} {
    font-size: 16px;
    line-height: 20px;
  }
  @media ${device.desktopXL} {
    font-size: 25px;
    line-height: 30px;
  }
`
